import React from 'react';

const JPKVAT = () => {
  return (
    <div>
      <h1>JPK VAT</h1>
    </div>
  );
};

export default JPKVAT;
